import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductCompatibility, ProductCompatibilityDataService } from '@vi-succ/products-domain';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EtProductCompatibilityDataService implements ProductCompatibilityDataService {
  constructor(private http: HttpClient) {}

  isCompatible(
    salesOrg: string,
    language: string,
    materialNumber: string,
    compareMaterialNumber: string
  ): Observable<ProductCompatibility> {
    return this.http.get<ProductCompatibility>(
      `${environment.backend.url}/product/${salesOrg}/${language}/${materialNumber}/compatibility`,
      {
        params: {
          searchToken: compareMaterialNumber,
        },
      }
    );
  }
}
